/**
 * Minimal markdown → HTML for copilot-inserted report drafts. HTML is escaped
 * first, then a small set of rules (bold, italic, headings, unordered lists,
 * paragraphs) is applied — enough for the conclusion/findings prose the
 * copilot produces, without pulling a markdown dependency.
 */

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function inline(text: string): string {
  return text
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>');
}

export function markdownToHtml(markdown: string): string {
  const lines = escapeHtml(markdown).split('\n');
  const out: string[] = [];
  let inList = false;

  const closeList = () => {
    if (inList) {
      out.push('</ul>');
      inList = false;
    }
  };

  lines.forEach((line) => {
    const heading = line.match(/^(#{1,3})\s+(.*)$/);
    if (heading) {
      closeList();
      const level = heading[1].length;
      out.push(`<h${level}>${inline(heading[2])}</h${level}>`);
      return;
    }
    const bullet = line.match(/^\s*[-*]\s+(.*)$/);
    if (bullet) {
      if (!inList) {
        out.push('<ul>');
        inList = true;
      }
      out.push(`<li>${inline(bullet[1])}</li>`);
      return;
    }
    closeList();
    if (line.trim() !== '') out.push(`<p>${inline(line)}</p>`);
  });
  closeList();
  return out.join('');
}
